import axios from 'axios';

export const getEntities = (api, params) => {
  const queryParams = params
    ? Object.keys(params)
        .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
        .join('&')
    : '';

  return axios.get(`${api}?${queryParams}&cacheBuster=${new Date().getTime()}`);
};

export const buildQueryParams = params => {
  return params
    ? Object.keys(params)
        .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
        .join('&')
    : '';
};

export const postEntities = (api, params, filters) => {
  const queryParams = buildQueryParams(params);

  return axios.post(`${api}?${queryParams}&cacheBuster=${new Date().getTime()}`, filters);
};

export const postEntitiesAsBlob = (api, params, filters) => {
  const queryParams = buildQueryParams(params);

  return axios.post(`${api}?${queryParams}&cacheBuster=${new Date().getTime()}`, filters, {
    responseType: 'blob',
    timeout: 5 * 60 * 1000,
  });
};
